var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 31,
    rx: 5.5,
    stroke: "#DFE3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1915 10L5 21.8265H11.2149L11.9854 19.9408H13.7465L14.517 21.8265H21.3579V20.3873L21.9674 21.8265H25.5061L26.1156 20.3569V21.8265H40.3428L42.0728 19.9898L43.6926 21.8265L51 21.8417L45.7921 15.9462L51 10H43.806L42.122 11.8027L40.5531 10H25.0758L23.7467 13.0525L22.3865 10H16.1846V11.3902L15.4947 10H10.1915ZM11.3942 11.6794H14.4236L17.8671 19.699V11.6794H21.1858L23.8455 17.4294L26.2967 11.6794H29.5988V20.1656H27.5895L27.5731 13.5159L24.6439 20.1656H22.8465L19.9009 13.5159V20.1656H15.7674L14.9838 18.2631H10.7502L9.96821 20.164H7.75357L11.3942 11.6794ZM39.6069 11.6794H31.437V20.1606H39.4805L42.073 17.3498L44.5718 20.1606H47.1839L43.3872 15.9446L47.1839 11.6794H44.6851L42.1057 14.4579L39.6069 11.6794ZM12.8677 13.1152L11.4729 16.5044H14.2609L12.8677 13.1152ZM33.4543 14.9856V13.435H38.5521L40.7764 15.9125L38.4535 18.4035H33.4543V16.7123H37.9113V14.9856H33.4543Z",
    fill: "#016FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.88662d321cc4a45a3a55cf582c14c87d.svg";
export { ForwardRef as ReactComponent };